"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importStar(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
const option_1 = require("../option");
// @ts-ignore
const lodash_1 = __importDefault(require("lodash"));
const react_i18next_1 = require("react-i18next");
exports.Button = react_1.default.memo(({ id, className, text, secondText, option, tablIndex, styles, onClick, ellipsis }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const buttonOption = (0, react_1.useMemo)(() => lodash_1.default.merge({}, option_1.ButtonOption, option), [option]);
    return (react_1.default.createElement("button", { id: id, className: `button ${className} ${onClick ? 'cursor-pointer' : 'cursor-default'}`, onClick: e => {
            e.preventDefault();
            onClick && onClick(e);
        }, tabIndex: tablIndex, style: styles?.buttonWrap },
        buttonOption.buttonBeforeIcon.show && (react_1.default.createElement(Icon_1.default, { className: buttonOption.buttonBeforeIcon.className, icon: buttonOption.buttonBeforeIcon.name, size: buttonOption.buttonBeforeIcon.size, width: buttonOption.buttonBeforeIcon.width, height: buttonOption.buttonBeforeIcon.height, fill: buttonOption.buttonBeforeIcon.color, stroke: buttonOption.buttonBeforeIcon.stroke })),
        text && (react_1.default.createElement("p", { className: "overText", style: ellipsis && {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            } }, t(text))),
        secondText && (react_1.default.createElement("p", { className: "overText", style: ellipsis && {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            } }, t(secondText))),
        buttonOption.buttonAfterIcon.show && (react_1.default.createElement(Icon_1.default, { className: buttonOption.buttonAfterIcon.className, icon: buttonOption.buttonAfterIcon.name, size: buttonOption.buttonAfterIcon.size, width: buttonOption.buttonBeforeIcon.width, height: buttonOption.buttonBeforeIcon.height, fill: buttonOption.buttonAfterIcon.color, stroke: buttonOption.buttonBeforeIcon.stroke }))));
});
